module.exports = __webpack_public_path__ + "img/头部.ff20fe3f.png";